import { LocalIcon, Text } from '~/shared/ui'

interface PrefixSuggestionCardProps {
  prefix: string
  description: string
}

export function PrefixSuggestionCard({ prefix, description }: PrefixSuggestionCardProps) {
  if (!prefix) return null

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        <LocalIcon
          name="opti"
          size="18"
          className="text-content-medium-emphasis"
        />
        <Text appearance="BODY2">opti Suggestion and Reasoning</Text>
      </div>
      <Text
        appearance="BODY2"
        className="text-teal-700"
      >
        <LocalIcon
          name="wbIncandescent"
          size="14"
          className="mr-1 inline-block align-text-bottom text-teal-700"
        />
        {prefix}
      </Text>
      <Text
        appearance="CAPTION"
        className="text-sm"
      >
        {description}
      </Text>
    </div>
  )
}
